module.exports = __webpack_public_path__ + "fonts/Merriweather-400-latin16.5c271de.woff2";